function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { BaseCard, CardVariant } from './BaseCard';
import { borderRadius, spacing, themeLight } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { MemberLabel } from '@naf/label';
export const CardList = /*#__PURE__*/forwardRef(({
  advancedImage,
  img,
  title,
  headerTag = 'h3',
  memberLabel,
  width,
  variant = CardVariant.Standard,
  children,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(ListCard, _extends({
    variant: variant,
    ref: ref
  }, rest), (img || advancedImage) && /*#__PURE__*/React.createElement(ImgWrap, null, advancedImage && advancedImage, img && !advancedImage && /*#__PURE__*/React.createElement("img", {
    src: img.src,
    alt: img.alt
  })), /*#__PURE__*/React.createElement(Content, null, memberLabel && /*#__PURE__*/React.createElement(CardLabel, memberLabel), title && /*#__PURE__*/React.createElement(Header, {
    tag: headerTag,
    variant: variant === 'small' ? TextVariant.ArticleTextHeader : TextVariant.CardHeader
  }, /*#__PURE__*/React.createElement(HoverWrap, null, title)), /*#__PURE__*/React.createElement(Body, null, children)));
});
const HoverWrap = styled.span.withConfig({
  displayName: "CardList__HoverWrap",
  componentId: "sc-1227xae-0"
})(["background-size:0 2px;background-position:0 100%;background-image:linear-gradient( 90deg,", ",", " );background-repeat:no-repeat;transition:background-size 0.3s ease;text-decoration:none;display:inline;"], ({
  theme
}) => theme.componentColors ? theme.componentColors.interactiveElement.active : themeLight.componentColors.interactiveElement.active, ({
  theme
}) => theme.componentColors ? theme.componentColors.interactiveElement.active : themeLight.componentColors.interactiveElement.active);
const ListCard = styled(BaseCard).withConfig({
  displayName: "CardList__ListCard",
  componentId: "sc-1227xae-1"
})(["", ""], ({
  isNotClickable
}) => isNotClickable ? null : css(["&:hover{img{transform:scale(1.02);}", "{background-size:100% 2px;}}"], HoverWrap));
const ImgWrap = styled.figure.withConfig({
  displayName: "CardList__ImgWrap",
  componentId: "sc-1227xae-2"
})(["margin:0;overflow:hidden;flex:none;border-radius:", ";img{height:100%;width:100%;object-fit:cover;transition:transform 0.6s ease;}"], borderRadius.S);
const Content = styled.div.withConfig({
  displayName: "CardList__Content",
  componentId: "sc-1227xae-3"
})(["display:flex;flex-wrap:wrap;align-content:flex-start;position:relative;"]);
const CardLabel = styled(MemberLabel).withConfig({
  displayName: "CardList__CardLabel",
  componentId: "sc-1227xae-4"
})(["margin-bottom:", ";margin-right:100%;white-space:nowrap;"], spacing.space8);
const Header = styled(Text).withConfig({
  displayName: "CardList__Header",
  componentId: "sc-1227xae-5"
})(["margin:0;margin-bottom:", ";"], spacing.space8);
const Body = styled.span.withConfig({
  displayName: "CardList__Body",
  componentId: "sc-1227xae-6"
})(["flex-basis:100%;"]);
//# sourceMappingURL=CardList.js.map